export default "__VITE_ASSET__6cQLiuED__"